import type { ReactNode } from "react";
import { useMemo } from "react";

import { buildFilterTitleByKey } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/buildFilterTitleByKey";
import type { TeamFilterTitles } from "app/pages/sales-intelligence/modules/teams/components/TeamFiltersTooltip/teamFilterTitlesContext";
import { TeamFilterTitlesContext } from "app/pages/sales-intelligence/modules/teams/components/TeamFiltersTooltip/teamFilterTitlesContext";

import { useTeamFiltersBootstrap } from "../TeamFiltersContainer/useTeamFiltersBootstrap";
import { useTeamFiltersConfig } from "../TeamFiltersContainer/useTeamFiltersConfig";

type Props = {
    children: ReactNode;
};

/**
 * Builds the filter key→title map (used to count and label a team's filters) from the same config the
 * Filters tab uses, and warms the shared SI store the config reads.
 */
export const TeamFilterTitlesProvider = ({ children }: Props) => {
    useTeamFiltersBootstrap();

    const { filtersList, status } = useTeamFiltersConfig();

    const titles = useMemo<TeamFilterTitles>(
        () => ({ byKey: buildFilterTitleByKey(filtersList), isReady: status === "ready" }),
        [filtersList, status],
    );

    return <TeamFilterTitlesContext.Provider value={titles}>{children}</TeamFilterTitlesContext.Provider>;
};
